// frontend/src/pages/PayrollItems/components/PayTypesBody.tsx
// Pay types section body: Active/Inactive radios + grid of pay-type cards.

import React, { useState } from "react";
import { PAY_TYPES } from "../data";
import { BORDER, BG_CARD, TEXT_INK, TEXT_SECONDARY, TEXT_TERTIARY } from "../styles";
import RadioOpt from "./RadioOpt";

type Segment = "active" | "inactive";

export default function PayTypesBody(): React.ReactElement {
  const [seg, setSeg] = useState<Segment>("active");

  const active = PAY_TYPES.filter((p) => p.active);
  const inactive = PAY_TYPES.filter((p) => !p.active);
  const list = seg === "active" ? active : inactive;

  return (
    <>
      {/* Active / Inactive segmented control */}
      <div style={{ display: "flex", gap: 24, marginBottom: 18 }}>
        <RadioOpt
          label={"Active (" + active.length + ")"}
          on={seg === "active"}
          onClick={() => setSeg("active")}
        />
        <RadioOpt
          label={"Inactive (" + inactive.length + ")"}
          on={seg === "inactive"}
          onClick={() => setSeg("inactive")}
        />
      </div>

      {/* Grid of pay-type cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0,1fr))", gap: 12 }}>
        {list.map((p) => (
          <div
            key={p.id}
            style={{
              border: "0.5px solid " + BORDER,
              borderRadius: 10,
              padding: "16px 18px",
              background: BG_CARD,
            }}
          >
            {p.cat && (
              <div style={{ fontSize: 12, color: TEXT_TERTIARY, marginBottom: 3 }}>
                {p.cat}
              </div>
            )}
            <div style={{ fontSize: 15, fontWeight: 600, color: TEXT_INK }}>
              {p.name}
            </div>
          </div>
        ))}

        {list.length === 0 && (
          <div
            style={{
              gridColumn: "1 / -1",
              padding: 22,
              color: TEXT_SECONDARY,
              fontSize: 14,
            }}
          >
            No {seg} pay types.
          </div>
        )}
      </div>
    </>
  );
}